import { TRESPONSE_LotListing, TRESPONSE_TestReportListing } from '@monorepo/types';
import { TTableTreeModel } from 'libs/ui/src/lib/table/models';
import { ModifiersZTableModel } from 'libs/ui/src/lib/table/models/table.modifier';
import { TTableCellTree } from '../../table.type';

export const LOT_TABLE_MODEL = {
  colorFieldDisabledFactories: ['ind-raj-ut6'] as string[],
  invoiceFieldEnabledFactories: ['bgd-bga-gpl'] as string[],

  getHeaderName: (headerConfig: TRESPONSE_LotListing['headerConfig'], headerKey: string): string => {
    return headerConfig.filter((item) => item.headerKey === headerKey)[0]?.displayName?.toUpperCase();
  },

  creatTableModel: (
    inputs: TRESPONSE_LotListing['items'],
    headerConfig: TRESPONSE_LotListing['headerConfig'],
    factoryId: string,
  ): TTableTreeModel<TRESPONSE_LotListing['items'][number]> => {
    const isColorFieldEnabled = !LOT_TABLE_MODEL.colorFieldDisabledFactories.includes(factoryId);
    const isInvoiceFieldEnabled = LOT_TABLE_MODEL.invoiceFieldEnabledFactories.includes(factoryId);
    const isPlmExists = inputs.length > 0 && !!inputs[0].metadata.plm;
    return ModifiersZTableModel.createTableModel(
      inputs,
      {
        select: {
          position: 'START',
          isMulti: false,
          size: 'LARGE',
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'supplierName') || 'lot_table_model.supplier_name',
          },
          {
            type: 'TEXT_CELL',
            text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'supplierPo') || 'lot_table_model.supplier_po_no',
          },
          {
            type: 'TEXT_CELL',
            text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'buyer') || 'lot_table_model.buyer',
          },
          ...(isPlmExists
            ? [
                {
                  type: 'TEXT_CELL',
                  text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'plm') || 'lot_table_model.plm',
                } as TTableCellTree,
              ]
            : []),
          {
            type: 'TEXT_CELL',
            text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'po') || 'lot_table_model.buyer_po_no',
          },

          {
            type: 'TEXT_CELL',
            text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'style') || 'lot_table_model.style',
          },
          {
            type: 'TEXT_CELL',
            text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'fabricType') || 'lot_table_model.fab_type',
          },
          {
            type: 'TEXT_CELL',
            text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'materialCode') || 'lot_table_model.material_code',
          },
          {
            type: 'TEXT_CELL',
            text:
              LOT_TABLE_MODEL.getHeaderName(headerConfig, 'fabricDescription') || 'lot_table_model.fabric_description',
          },
          ...(isColorFieldEnabled
            ? [
                {
                  type: 'TEXT_CELL',
                  text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'color') || 'lot_table_model.color',
                } as TTableCellTree,
              ]
            : []),
          {
            type: 'TEXT_CELL',
            text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'fabricColor') || 'lot_table_model.fabric_color',
          },
          {
            type: 'TEXT_CELL',
            text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'lotNo') || 'lot_table_model.lot_batch_no',
          },
          ...(isInvoiceFieldEnabled
            ? [
                {
                  type: 'TEXT_CELL',
                  text: LOT_TABLE_MODEL.getHeaderName(headerConfig, 'invoice') || 'lot_table_model.invoice',
                } as TTableCellTree,
              ]
            : []),
          {
            type: 'TEXT_CELL',
            text: 'lot_table_model.status',
          },

          {
            type: 'TEXT_CELL',
            text: 'lot_table_model.view',
            stickyType: 'RIGHT',
          },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.metadata.supplierName,
            },
            {
              type: 'TEXT_CELL',
              text: item.metadata.supplierPo,
            },
            {
              type: 'TEXT_CELL',
              text: item.metadata.buyer,
            },
            ...(isPlmExists
              ? [
                  {
                    type: 'TEXT_CELL',
                    text: item.metadata.plm,
                  } as TTableCellTree,
                ]
              : []),
            {
              type: 'TEXT_CELL',
              text: item.metadata.po,
            },

            {
              type: 'TEXT_CELL',
              text: item.metadata.style,
            },
            {
              type: 'TEXT_CELL',
              text: item.metadata.fabricType,
            },
            {
              type: 'TEXT_CELL',
              text: item.metadata.materialCode,
            },
            {
              type: 'TEXT_CELL',
              text: item.metadata.fabricDescription,
            },
            ...(isColorFieldEnabled
              ? [
                  {
                    type: 'TEXT_CELL',
                    text: item.metadata.color,
                  } as TTableCellTree,
                ]
              : []),
            {
              type: 'TEXT_CELL',
              text: item.metadata.fabricColor,
            },
            {
              type: 'TEXT_CELL',
              text: item.metadata.lotNo,
            },
            ...(isInvoiceFieldEnabled
              ? [
                  {
                    type: 'TEXT_CELL',
                    text: item.metadata.invoice ?? '-',
                  } as TTableCellTree,
                ]
              : []),
            {
              type: 'TEXT_CELL',
              text: `lot_table_model.${item.status}`,
            },
            {
              type: 'ACTION_CELL',
              actionType: 'VIEW',
              actionName: 'lot_table_model.view',
            },
          ],
        };
      },
    );
  },

  createTestReportTableModel: (
    inputs: TRESPONSE_TestReportListing['items'],
    headerConfig: TRESPONSE_TestReportListing['headerConfig'],
  ): TTableTreeModel<TRESPONSE_TestReportListing['items'][number]> => {
    return ModifiersZTableModel.createTableModel(
      inputs,
      {
        select: {
          position: 'START',
          isMulti: true,
          size: 'LARGE',
        },
        headerConfig: [
          ...headerConfig.map((hC) => {
            return {
              type: 'TEXT_CELL' as const,
              text: hC.displayName,
            };
          }),
          {
            type: 'TEXT_CELL',
            align: 'center',
            stickyType: 'RIGHT',
            text: 'lot_table_model.actions',
          },
          {
            type: 'TEXT_CELL',
            stickyType: 'RIGHT',
            text: 'lot_table_model.report_status',
          },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            ...headerConfig.map((hC) => {
              return {
                type: 'TEXT_CELL' as const,
                text: item[hC.headerKey] || '',
              };
            }),
            item.testReportStatus
              ? {
                  type: 'ACTION_CELL',
                  actionType: 'VIEW',
                  actionName: 'lot_table_model.view',
                }
              : {
                  type: 'BUTTON_CELL',
                  btnText: 'lot_table_model.upload_report',
                  btnType: 'PRIMARY',
                },
            {
              type: 'TEXT_CELL',
              text: item.testReportStatus ? `lot_table_model.${item.testReportStatus}` : '-',
              textColor: item.testReportStatus === 'PASS' ? 'GREEN' : 'RED',
            },
          ],
        };
      },
    );
  },
};
